import React, { useState, useEffect } from 'react';
import CloseButton from '../../images/close_button.svg';
import '../../pages/explore/explore.css';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import downloadapp from '../../images/app_download.svg'
import { DownloadSubmitButtonClick } from '../../utils/Analytics';


function MobileDownloadAlert({handleClose}) {
      const handleRedirect = () => {
        DownloadSubmitButtonClick();
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
         if (/android/i.test(userAgent)) {
          window.location.href = "https://play.google.com/store/apps/details?id=com.edaya.guestapp&pli=1";
        }
         else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        } 
         else { 
          window.location.href = "https://edayaapp.com/appDownloadlink";  
        }
      };

  return (
    <>
    
        <div className='flex justify-center items-center section-wrap'>
          <aside className='fade-in alert-banner py-2 px-2 mb-2 flex items-center justify-between gap-3 '>
            <h1 className='text-[14px] max-md:text-[14px] max-sm:text-[12px] text-[#181818] '>
              Download Edaya app for a better experience
            </h1>
            <div className='flex gap-2 shrink-0'>
              <div className="flex items-center gap-3 shrink-0 bg-[white] text-[black] rounded-[8px] login-head" >
              <div  onClick={()=>handleRedirect()} rel="noopener noreferrer" className="download-btn cursor-pointer"> 
                  <span className="download-text">Download App</span>
                  <img src={downloadapp} alt="Download App" className="download-image shrink-0 " />
              </div>
              </div>
              <button onClick={()=>handleClose()} aria-label="Close banner" className='shrink-0'>
                <img src={CloseButton} className='w-[20px] ' alt='close' />
              </button>
            </div>
          </aside>
        </div>
      
    </>
  );
}

export default MobileDownloadAlert;
